import { CategoryDirectory } from "../../directory/category";

export class responsecreateProduct {
    category: CategoryDirectory;
    dealerGroupId: number;
    name: string;
    ordinal: string;
    productCategoryId: string;
    productId: number;
    constructor (data) {
        this.category = data.category;
        this.dealerGroupId = data.dealerGroupId;
        this.name = data.name;
        this.ordinal = data.ordinal;
        this.productCategoryId = data.productCategoryId;
        this.productId = data.productId;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/class/http/res/response-create-product.ts